import { NavLink, useLocation } from "react-router-dom";

const TableManagementSideBar = () => {
  const location = useLocation();
  return (
    <div
      className={`menu-item has-sub ${location.pathname.startsWith("/diningManagement") ||
        location.pathname.startsWith("/diningAreas") ||
        location.pathname.startsWith("/serviceArea")
        ? "active"
        : ""
        }`}
    >
      <div className="menu-link">
        <div className="menu-icon">
          <i className="fa-solid fa-table"></i>
        </div>
        <div className="menu-text">Dining Management</div>
        <div className="menu-caret"></div>
      </div>
      <div className="menu-submenu">
        <div
          className={`menu-item ${location.pathname.startsWith("/diningAreas") ? "active" : ""
            }`}
        >
          <NavLink to="/diningAreas" className="menu-link">
            Dining Areas
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default TableManagementSideBar;